import React, { useState } from 'react';

interface DeliciousmenuProps {
  language: string;
}

interface MenuItem {
  name: string;
  price: string;
}

interface MenuCategory {
  categoryName: string;
  items: MenuItem[];
}

const Deliciousmenu = ({ language }: DeliciousmenuProps) => {
  const [activeCategory, setActiveCategory] = useState(0);

  // Menu data with Portuguese and English versions
  const menuData = {
    pt: [
      {
        categoryName: "Entradas",
        items: [
          { name: "Carpaccio de Novilho com chutney de Alperce, amêndoas tostadas e Rúcula crocante", price: "16,30 €" },
          { name: "Queijo de Cabra gratinado com maçã assada, mel e nozes", price: "14,50 €" },
          { name: "Foi gras com creme de cenoura e Figo ao Vinho do Porto", price: "17,90 €" },
          { name: "Camarão Flambado em Brandy, e molho de queijo com alho e ervas", price: "16,50 €" },
          { name: "Espargos verdes grelhados com Tomate seco, Cogumelos selvagens e Parmesão", price: "14,40 €" },
          { name: "Sopa do Dia", price: "8,50 €" },
          { name: "Couvert para 2", price: "8,00 €" }
        ]
      },
      {
        categoryName: "Do Mar",
        items: [
          { name: "Corvina grelhada com creme de couve flor, figos ao Porto e amêndoas tostadas", price: "26,30 €" },
          { name: "Filet de Salmão com risotto de cogumelos selvagens, tomate seco e espuma de Trufa", price: "23,50 €" },
          { name: "Seleção de peixe em Molho Exótico de coco com legumes assados e castanha de caju", price: "24,50 €" }
        ]
      },
      {
        categoryName: "Do Jardim",
        items: [
          { name: "Risoto de cogumelos e espargos verdes com lascas de parmesão e óleo de Trufa", price: "21,50 €" },
          { name: "Ravioli caseiro de espinafre com molho de queijo azul, Pera ao Porto e amêndoas tostadas", price: "23,90 €" },
          { name: "Polenta no forno com Legumes Salteados, chutney de Alperce e castanha de caju", price: "19,90 €" }
        ]
      },
      {
        categoryName: "Do Campo",
        items: [
          { name: "Peito de Pato com creme de Cenoura, Crumble de Maçã é molho de Chocolate", price: "27,50 €" },
          { name: "Carré de Borrego com Ervas é Alho, Polenta no Forno é Legumes", price: "38,00 €" },
          { name: "Lombo de Novilho com Cogumelos selvagem, Espargos verdes é molho de Whisky", price: "36,00 €" },
          { name: "Bochechas de Porco em baixa temperatura, puré de Couve flor é Pera ao Vinho do Porto", price: "28,50 €" }
        ]
      },
      {
        categoryName: "Sobremesa",
        items: [
          { name: "Bolo de Tâmaras com Caramelo e molho de Baunilha", price: "9,50 €" },
          { name: "Creme Brulee com frutos silvestres", price: "8,90 €" },
          { name: "Creme de Mel e Canela com molho de maracujá e Ameixas ao Vinho do Porto", price: "9,50 €" },
          { name: "Brownie de Chocolate com molho de Café, Gelado de Baunilha e crumble de Amendoim", price: "9,30 €" },
          { name: "Seleção de Queijos com Bolachas e Geleia caseira", price: "11,90 €" }
        ]
      }
    ],
    en: [
      {
        categoryName: "Starters",
        items: [
          { name: "Beef Carpaccio with dried Apricot chutney, toasted Almonds and crispy Rúcula", price: "16,30 €" },
          { name: "Gratinated Goat Cheese with baked Apple, Honey and Walnuts", price: "14,50 €" },
          { name: "Fried Foie Gras with Carrot cream and fig in Port wine", price: "17,90 €" },
          { name: "Flambeed Prawns in Brandy, with Cheese sauce, Garlic and Herbs", price: "16,50 €" },
          { name: "Grilled green Asparagus with sundried Tomatoes, wild Mushrooms and Parmesan Cheese", price: "14,40 €" },
          { name: "Soup of the Day", price: "8,50 €" },
          { name: "Couvert for 2", price: "8,00 €" }
        ]
      },
      {
        categoryName: "From the Sea",
        items: [
          { name: "Grilled Corvina with Cauliflower cream, fig in Port wine and toasted Almonds", price: "26,30 €" },
          { name: "Salmon Fillet with Mushroom Risotto and green Asparagus, Sun dried Tomato and Truffle foam", price: "23,50 €" },
          { name: "Fish Selection in Coconut Sauce with roasted Vegetables and Cashew Nuts", price: "24,50 €" }
        ]
      },
      {
        categoryName: "From the Garden",
        items: [
          { name: "Mushroom and green Asparagus Risotto with Parmesan shavings and Truffle oil", price: "21,50 €" },
          { name: "Spinach Ravioli with blue Cheese Sauce, Pear in Port Wine and toasted Almonds", price: "23,90 €" },
          { name: "Baked Polenta with sautéed Vegetables, dried Apricot chutney and Cashew Nuts", price: "19,90 €" }
        ]
      },
      {
        categoryName: "From the Farm",
        items: [
          { name: "Duck Breast with Carrot cream, Apple crumble and Chocolate sauce", price: "27,50 €" },
          { name: "Lamb Rack with Herbs and Garlic, baked Polenta and sauteed Vegetables", price: "38,00 €" },
          { name: "National Beef fillet with wild Mushrooms, green Asparagus and Whisky sauce", price: "36,00 €" },
          { name: "Slow cooked Pork Cheeks with Cauliflower puree and Pear in Port wine", price: "28,50 €" }
        ]
      },
      {
        categoryName: "Desserts",
        items: [
          { name: "Sticky Toffee Pudding with Custard sauce", price: "9,50 €" },
          { name: "Creme Brulee with Red berries", price: "8,90 €" },
          { name: "Honey and Cinnamon cream with Passion fruit sauce and Prunes in Port wine", price: "9,50 €" },
          { name: "Chocolate Brownie with Coffee Sauce, Vanilla Ice Cream and Peanut crumble", price: "9,30 €" },
          { name: "Cheese Selection with Crackers and home made Jam", price: "11,90 €" }
        ]
      }
    ]
  };

  const currentMenu = menuData[language === 'pt' ? 'pt' : 'en'];

  return (
    <section className="menu-section bg-gradient-to-br from-slate-50 to-gray-100" id="menu" style={{ paddingBottom: '23px' }}>
      <div className="container mx-auto px-4 max-w-6xl">
        {/* Header with sophisticated styling */}
        <div className="text-center mb-0">
          <div className="inline-block">
            <p className="font-medium tracking-wide uppercase text-sm mb-3" style={{ color: '#cb6e92' }}>
              {language === 'en' ? 'Our Culinary Selection' : 'Nossa Seleção Culinária'}
            </p>
            <h2 className="font-bold text-gray-800 mb-6 font-serif" style={{ fontSize: '35.7px' }}>
              {language === 'en' ? 'Delicious Menu' : 'Menu Delicioso'}
            </h2>
            <div className="w-24 h-0.5 mx-auto mb-8" style={{ backgroundColor: '#cb6e92' }}></div>
          </div>
        </div>

        {/* Navigation Cards - Show All Categories */}
        <div className="mb-12">
          <div className="flex flex-wrap justify-center gap-3 pb-2">
            {currentMenu.map((category, index) => (
              <button
                key={index}
                onClick={() => setActiveCategory(index)}
                className={`flex-shrink-0 px-6 py-3 lg:px-8 lg:py-4 rounded-2xl font-semibold text-sm lg:text-base transition-all duration-300 border-2 ${
                  activeCategory === index
                    ? 'text-white shadow-lg transform scale-105'
                    : 'bg-white text-gray-700 border-gray-200 hover:bg-pink-50'
                }`}
                style={activeCategory === index 
                  ? { backgroundColor: '#cb6e92', borderColor: '#cb6e92' }
                  : { borderColor: '#d1d5db' }
                }
              >
                {category.categoryName}
              </button>
            ))}
          </div>
        </div>

        {/* Menu Items - Elegant Card Layout */}
        <div className="bg-white rounded-3xl shadow-xl p-8 lg:p-12 border border-gray-100" style={{ paddingTop: '0px' }}>
          {/* Category Title */}
          <div className="text-center mb-10">
            <h3 className="text-3xl lg:text-4xl font-bold text-gray-800 font-serif mb-4">
              {currentMenu[activeCategory].categoryName}
            </h3>
            <div className="w-16 h-0.5 mx-auto" style={{ backgroundColor: '#cb6e92' }}></div>
          </div>
          
          {/* Menu Items Grid */}
          <div className="grid gap-6 lg:gap-8">
            {currentMenu[activeCategory].items.map((item, itemIndex) => (
              <div 
                key={itemIndex} 
                className="group bg-gray-50 rounded-2xl p-6 lg:p-8 transition-all duration-300 hover:bg-white hover:shadow-md border border-transparent hover:border-pink-100"
              >
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
                  {/* Item Name */}
                  <div className="flex-1 mb-3 lg:mb-0 lg:pr-6">
                    <h4 className="text-lg lg:text-xl font-semibold text-gray-800 leading-relaxed transition-colors duration-300 group-hover:text-gray-600">
                      {item.name}
                    </h4>
                  </div>
                  
                  {/* Price with decorative dots */}
                  <div className="flex items-center lg:flex-shrink-0">
                    <div className="hidden lg:flex flex-1 border-b border-dotted border-gray-300 mx-4 min-w-[2rem]"></div>
                    <div className="text-white px-4 py-2 rounded-full font-bold text-lg shadow-sm" style={{ backgroundColor: '#cb6e92' }}>
                      {item.price}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Decorative Bottom Element */}
        <div className="text-center mt-16">
          <div className="inline-flex items-center gap-4">
            <div className="w-8 h-0.5" style={{ backgroundColor: '#cb6e92' }}></div>
            <div className="w-2 h-2 rounded-full" style={{ backgroundColor: '#cb6e92' }}></div>
            <div className="w-8 h-0.5" style={{ backgroundColor: '#cb6e92' }}></div>
          </div>
        </div>
      </div>

      {/* Custom Styles for hiding scrollbar */}
      <style dangerouslySetInnerHTML={{
        __html: `
          .scrollbar-hide {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
          .scrollbar-hide::-webkit-scrollbar {
            display: none;
          }


          /* Element | http://localhost:3000/ */

          #menu {
            /* padding-bottom: 23px; */
            padding-bottom: 2px;
            padding-top: 0px;
          }
          
          /* Element | http://localhost:3000/ */
          
          .mt-16 {
            margin-bottom: 0px;
            margin-top: 40px;
          }
          
          /* Element | http://localhost:3000/ */
          
          .text-col {
            margin-bottom: 0px;
          }
          #contact {
  padding-top: 32px;
}
.text-3xl {
  margin-top: 14px;
}
#about {
  padding-bottom: 6px;
}
.review-modal {
  padding-left: 10px;
  padding-right: 12px;
}


        `
      }} />
    </section>
  );
};

export default Deliciousmenu; 